import { useState, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import CardOpciones from "../CardOpciones";
import ConvertirStringHTML from "../ConvertirStringHTML";
import { useWhatsAppConsulta } from "../../config/WhatsAppConsultaContext";

// Formulario legacy: ModalContacto + Formulario — conservado en el repo para posible recuperación

import checkIcon from "../../assets/check-square.png";

import checkIconNew from "../../assets/check-square_new.png";

const MOBILE_MAX_WIDTH = 767;

const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const mq = window.matchMedia(`(max-width: ${MOBILE_MAX_WIDTH}px)`);
    const update = () => setIsMobile(mq.matches);
    update();
    mq.addEventListener("change", update);
    return () => mq.removeEventListener("change", update);
  }, []);

  return isMobile;
};

const VehicleCard = (vehiculo) => {
  const { openConsultaForm } = useWhatsAppConsulta();
  const isMobile = useIsMobile();

  const handleConsultar = (modelo, version, tipo, tipo_financiacion) => {
    window.dataLayer.push({
      modelo: modelo,
      version: version,
      seccion: tipo,
      event: "consultar",
      tipo_financiacion: tipo_financiacion,
    });

    openConsultaForm();
  };

  const getCardInteraction = (modelo, version, tipoFinanciacion) => {
    const onConsult = () => handleConsultar(modelo, version, vehiculo.tipo, tipoFinanciacion);

    return {
      sectionClassName: isMobile ? " card-new-vehicle--tappable" : "",
      sectionOnClick: isMobile ? onConsult : undefined,
      buttonOnClick: isMobile ? undefined : onConsult,
    };
  };

  const tipo = vehiculo.tipo;

  return (
    <div className="h-100 d-block w-100">
      {vehiculo.info.convencional.habilitado && vehiculo.nombreTipo === "convencional"
        ? (() => {
            const card = vehiculo.info.convencional;
            const interaction = getCardInteraction(card.version, card.modelo, card.titulo_principal);

            return (
              <section
                className={`card-new-vehicle h-100 d-flex justify-content-between flex-column${interaction.sectionClassName}`}
                onClick={interaction.sectionOnClick}
              >
          <div>
            <div className="card-new-vehicle-header">
              <h2 className="titulo-tarjeta"> {vehiculo.info.convencional.modelo} </h2>
              {vehiculo.info.convencional.version !== "" ? (
                <h3 className="titulo-version-tarjeta"> {vehiculo.info.convencional.version} </h3>
              ) : null}
            </div>
            <div className="card-new-vehicle-imagen">
              <img
                src={vehiculo.info.convencional.main_picture}
                alt={vehiculo.info.convencional.modelo}
                className="img-fluid"
              />
            </div>
            <div className="card-new-vehicle-footer">
              {vehiculo.info.convencional.entrega_inmediata ? (
                <div className="vehicle-footer-entrega-inmediata">
                  <p>
                    {" "}
                    <img src={checkIcon} alt="Icon Check" /> ENTREGA INMEDIATA
                  </p>
                </div>
              ) : null}

              {vehiculo.info.convencional?.preventa ? (
                <div className="vehicle-footer-entrega-inmediata">
                  <p>
                    {" "}
                    <img src={checkIcon} alt="Icon Check" /> PREVENTA EXCLUSIVA
                  </p>
                </div>
              ) : null}

              {vehiculo.info.convencional.labelCheck ? (
                <div className="vehicle-footer-entrega-inmediata">
                  <p
                    style={{
                      fontWeight: vehiculo.info.convencional.labelCheck.bold,
                      color: vehiculo.info.convencional.labelCheck.color,
                    }}
                  >
                    <img src={vehiculo.info.convencional.labelCheck.icono} alt="Icon Check" />

                    {vehiculo.info.convencional.labelCheck.texto}
                  </p>
                </div>
              ) : null}

              {vehiculo.info.convencional.nuevo && vehiculo.info.convencional.nuevo ? (
                <div className="vehicle-footer-entrega-inmediata">
                  <p
                    style={{
                      color: "#1400F8",
                    }}
                  >
                    {" "}
                    <img src={checkIconNew} alt="Icon Check" /> NUEVO MODELO
                  </p>
                </div>
              ) : null}

              {vehiculo.info.convencional.descripcion_general.length !== "" ? (
                <div className="vehicle-footer-descripcion-general">
                  <p>{vehiculo.info.convencional.descripcion_general}</p>
                </div>
              ) : null}

              {vehiculo.info.convencional.subtitulo_principal !== "" ? (
                <div className="vehicle-footer-subtitulo-principal">
                  <p>{vehiculo.info.convencional.subtitulo_principal}</p>
                </div>
              ) : null}

              {vehiculo.info.convencional.descripcion_subtitulo_principal !== "" ? (
                <div className="vehicle-footer-descripcion-subtitulo-principal">
                  <p>{vehiculo.info.convencional.descripcion_subtitulo_principal}</p>
                </div>
              ) : null}

              <div className="vehicle-footer-titulo-principal">
                {vehiculo.info.convencional.titulo_principal !== ""
                  ? ConvertirStringHTML(
                      vehiculo.info.convencional.titulo_principal,
                      "vehicle-footer-titulo-principal-a"
                    )
                  : null}

                {vehiculo.info.convencional.descripcion_titulo_principal !== ""
                  ? ConvertirStringHTML(
                      vehiculo.info.convencional.descripcion_titulo_principal,
                      "vehicle-footer-titulo-principal-b"
                    )
                  : null}
                {vehiculo.info.convencional.soloEnMontironi ? (
                  <div className="vehicle-footer-entrega-inmediata">
                    <p
                      style={{
                        color: "#1400F8",
                        fontFamily: "FordAntennaWGL-Bold",
                      }}
                    >
                      SOLO EN MONTIRONI
                    </p>
                  </div>
                ) : null}
                {vehiculo.info.convencional.descripcion_rojo_titulo_principal !== ""
                  ? vehiculo.info.convencional.modelo !== "TERRITORY" &&
                    vehiculo.info.convencional.modelo !== "Ranger Raptor"
                    ? ConvertirStringHTML(
                        vehiculo.info.convencional.descripcion_rojo_titulo_principal,
                        "vehicle-footer-titulo-principal-c"
                      )
                    : ConvertirStringHTML(
                        vehiculo.info.convencional.descripcion_rojo_titulo_principal,
                        "vehicle-footer-titulo-principal-c colorBlackTerritory"
                      )
                  : null}
              </div>
            </div>
          </div>

                <div>
                  <button
                    type="button"
                    className="btn-consultar-card"
                    id={`${card.modelo.replace(/\s+/g, "-").toLowerCase()}-${tipo}`}
                    onClick={interaction.buttonOnClick}
                  >
                    Consultar
                  </button>
                </div>
              </section>
            );
          })()
        : vehiculo.info.grandesclientes &&
        vehiculo.info.grandesclientes.habilitado &&
        vehiculo.nombreTipo === "grandesclientes"
        ? (() => {
            const card = vehiculo.info.grandesclientes;
            const interaction = getCardInteraction(card.version, card.modelo, card.titulo_principal);

            return (
              <section
                className={`card-new-vehicle h-100 d-flex justify-content-between flex-column${interaction.sectionClassName}`}
                onClick={interaction.sectionOnClick}
              >
          <div>
            <div className="card-new-vehicle-header">
              <h2 className="titulo-tarjeta"> {vehiculo.info.grandesclientes.modelo} </h2>
              {vehiculo.info.grandesclientes.version !== "" ? (
                <h3 className="titulo-version-tarjeta"> {vehiculo.info.grandesclientes.version} </h3>
              ) : null}
            </div>
            <div className="card-new-vehicle-imagen">
              <img
                src={vehiculo.info.grandesclientes.main_picture}
                alt={vehiculo.info.grandesclientes.modelo}
                className="img-fluid"
              />
            </div>
            <div className="card-new-vehicle-footer">
              {vehiculo.info.grandesclientes.entrega_inmediata ? (
                <div className="vehicle-footer-entrega-inmediata">
                  <p>
                    {" "}
                    <img src={checkIcon} alt="Icon Check" /> ENTREGA INMEDIATA
                  </p>
                </div>
              ) : null}

              {vehiculo.info.grandesclientes.labelCheck ? (
                <div className="vehicle-footer-entrega-inmediata">
                  <p
                    style={{
                      fontWeight: vehiculo.info.grandesclientes.labelCheck.bold,
                      color: vehiculo.info.grandesclientes.labelCheck.color,
                    }}
                  >
                    <img src={vehiculo.info.grandesclientes.labelCheck.icono} alt="Icon Check" />

                    {vehiculo.info.grandesclientes.labelCheck.texto}
                  </p>
                </div>
              ) : null}

              {vehiculo.info.grandesclientes.disponibilidadInmediata ? (
                <div className="vehicle-footer-entrega-inmediata">
                  <p>
                    {" "}
                    <img src={checkIcon} alt="Icon Check" /> DISPONIBILIDAD INMEDIATA
                  </p>
                </div>
              ) : null}

              {vehiculo.info.grandesclientes.descripcion_general.length !== "" ? (
                <div className="vehicle-footer-descripcion-general">
                  <p>{vehiculo.info.grandesclientes.descripcion_general}</p>
                </div>
              ) : null}

              {vehiculo.info.grandesclientes.subtitulo_principal !== "" ? (
                <div className="vehicle-footer-subtitulo-principal">
                  <p>{vehiculo.info.grandesclientes.subtitulo_principal}</p>
                </div>
              ) : null}

              {vehiculo.info.grandesclientes.descripcion_subtitulo_principal !== "" ? (
                <div className="vehicle-footer-descripcion-subtitulo-principal">
                  <p>{vehiculo.info.grandesclientes.descripcion_subtitulo_principal}</p>
                </div>
              ) : null}

              <div className="vehicle-footer-titulo-principal">
                {vehiculo.info.grandesclientes.titulo_principal !== ""
                  ? ConvertirStringHTML(
                      vehiculo.info.grandesclientes.titulo_principal,
                      "vehicle-footer-titulo-principal-a"
                    )
                  : null}

                {vehiculo.info.grandesclientes.descripcion_titulo_principal !== ""
                  ? ConvertirStringHTML(
                      vehiculo.info.grandesclientes.descripcion_titulo_principal,
                      "vehicle-footer-titulo-principal-b"
                    )
                  : null}

                {vehiculo.info.grandesclientes.descripcion_rojo_titulo_principal !== ""
                  ? ConvertirStringHTML(
                      vehiculo.info.grandesclientes.descripcion_rojo_titulo_principal,
                      "vehicle-footer-titulo-principal-c"
                    )
                  : null}
              </div>
            </div>
          </div>

                <div>
                  <button
                    type="button"
                    className="btn-consultar-card"
                    id={`${card.modelo.replace(/\s+/g, "-").toLowerCase()}-${tipo}`}
                    onClick={interaction.buttonOnClick}
                  >
                    Consultar
                  </button>
                </div>
              </section>
            );
          })()
        : vehiculo.info.plan.habilitado && vehiculo.nombreTipo === "plan"
        ? (() => {
            const card = vehiculo.info.plan;
            const interaction = getCardInteraction(card.version, card.modelo, card.titulo_principal);

            return (
              <section
                className={`card-new-vehicle h-100 d-flex justify-content-between flex-column${interaction.sectionClassName}`}
                onClick={interaction.sectionOnClick}
              >
          <div>
            <div className="card-new-vehicle-header">
              <h2 className="titulo-tarjeta"> {vehiculo.info.plan.modelo} </h2>
              {vehiculo.info.plan.version !== "" ? (
                <h3 className="titulo-version-tarjeta"> {vehiculo.info.plan.version} </h3>
              ) : null}
            </div>
            <div className="card-new-vehicle-imagen">
              <img src={vehiculo.info.plan.main_picture} alt={vehiculo.info.plan.modelo} className="img-fluid" />
            </div>
            <div className="card-new-vehicle-footer">
              {vehiculo.info.plan.entrega_inmediata ? (
                <div className="vehicle-footer-entrega-inmediata">
                  <p>
                    {" "}
                    <img src={checkIcon} alt="Icon Check" /> ENTREGA INMEDIATA
                  </p>
                </div>
              ) : null}

              {vehiculo.info.plan.labelCheck ? (
                <div className="vehicle-footer-entrega-inmediata">
                  <p
                    style={{
                      fontWeight: vehiculo.info.plan.labelCheck.bold,
                      color: vehiculo.info.plan.labelCheck.color,
                    }}
                  >
                    <img src={vehiculo.info.plan.labelCheck.icono} alt="Icon Check" />

                    {vehiculo.info.plan.labelCheck.texto}
                  </p>
                </div>
              ) : null}

              {vehiculo.info.plan.tipos_planes[0].nombre_plan !== "" ? (
                <div className="vehicle-footer-planes-cuotas">
                  {vehiculo.info.plan.tipos_planes.map((plan, index) => {
                    return (
                      <div key={index} className="vehicle-footer-planes-cuotas-card">
                        <div className="vehicle-footer-planes-cuotas-card-header">
                          <p className="cuotas-card-header-titulo">{plan.nombre_plan}</p>
                          <div className="cuotas-card-header-cuotas-desde">                        
                            <p className="cuotas-card-header-cuotas-desde-precio">{plan.precio}</p>
                          </div>
                        </div>
                        <div className="vehicle-footer-planes-cuotas-card-footer">
                          <p>{plan.descripcion}</p>
                        </div>
                      </div>
                    );
                  })}
                </div>
              ) : null}

              {vehiculo.info.plan.descripcion_general.length !== "" ? (
                <div className="vehicle-footer-descripcion-general">
                  <p>{vehiculo.info.plan.descripcion_general}</p>
                </div>
              ) : null}

              {vehiculo.info.plan.subtitulo_principal !== "" ? (
                <div className="vehicle-footer-subtitulo-principal">
                  <p>{vehiculo.info.plan.subtitulo_principal}</p>
                </div>
              ) : null}

              {vehiculo.info.plan.descripcion_subtitulo_principal !== "" ? (
                <div className="vehicle-footer-descripcion-subtitulo-principal">
                  <p>{vehiculo.info.plan.descripcion_subtitulo_principal}</p>
                </div>
              ) : null}

              <div className="vehicle-footer-titulo-principal">
                {vehiculo.info.plan.titulo_principal !== ""
                  ? ConvertirStringHTML(vehiculo.info.plan.titulo_principal, "vehicle-footer-titulo-principal-a")
                  : null}

                {vehiculo.info.plan.descripcion_titulo_principal !== ""
                  ? ConvertirStringHTML(
                      vehiculo.info.plan.descripcion_titulo_principal,
                      "vehicle-footer-titulo-principal-b"
                    )
                  : null}

                {vehiculo.info.plan.descripcion_rojo_titulo_principal !== ""
                  ? ConvertirStringHTML(
                      vehiculo.info.plan.descripcion_rojo_titulo_principal,
                      "vehicle-footer-titulo-principal-c"
                    )
                  : null}
              </div>
            </div>
          </div>
                <div>
                  <button
                    type="button"
                    className="btn-consultar-card"
                    id={`${card.modelo.replace(/\s+/g, "-").toLowerCase()}-${tipo}`}
                    onClick={interaction.buttonOnClick}
                  >
                    Consultar
                  </button>
                </div>
              </section>
            );
          })()
        : vehiculo.info.preventa.habilitado && vehiculo.nombreTipo === "preventa"
        ? (() => {
            const card = vehiculo.info.preventa;
            const interaction = getCardInteraction(card.version, card.modelo, card.titulo_principal);

            return (
              <section
                className={`card-new-vehicle h-100 d-flex justify-content-between flex-column${interaction.sectionClassName}`}
                onClick={interaction.sectionOnClick}
              >
          <div>
            <div className="card-new-vehicle-header">
              <h2 className="titulo-tarjeta">{vehiculo.info.preventa.modelo}</h2>
              {vehiculo.info.preventa.version !== "" && (
                <h3 className="titulo-version-tarjeta">{vehiculo.info.preventa.version}</h3>
              )}
            </div>
            <div className="card-new-vehicle-imagen">
              <img
                src={vehiculo.info.preventa.main_picture}
                alt={vehiculo.info.preventa.modelo}
                className="img-fluid"
              />
            </div>
            <div className="card-new-vehicle-footer">
              {vehiculo.info.preventa.entrega_inmediata && (
                <div className="vehicle-footer-entrega-inmediata">
                  <p>
                    <img src={checkIcon} alt="Icon Check" /> ENTREGA INMEDIATA
                  </p>
                </div>
              )}
              {vehiculo.info.preventa.preventa && (
                <div className="vehicle-footer-entrega-inmediata">
                  <p>
                    <img src={checkIcon} alt="Icon Check" /> PREVENTA EXCLUSIVA
                  </p>
                </div>
              )}

              {vehiculo.info.preventa.labelCheck && (
                <div className="vehicle-footer-entrega-inmediata">
                  <p
                    style={{
                      fontWeight: vehiculo.info.preventa.labelCheck.bold,
                      color: vehiculo.info.preventa.labelCheck.color,
                    }}
                  >
                    <img src={vehiculo.info.preventa.labelCheck.icono} alt="Icon Check" />
                    {vehiculo.info.preventa.labelCheck.texto}
                  </p>
                </div>
              )}

              {vehiculo.info.preventa.descripcion_general.length !== "" && (
                <div className="vehicle-footer-descripcion-general">
                  <p>{vehiculo.info.preventa.descripcion_general}</p>
                </div>
              )}

              {vehiculo.info.preventa.subtitulo_principal !== "" && (
                <div className="vehicle-footer-subtitulo-principal">
                  <p>{vehiculo.info.preventa.subtitulo_principal}</p>
                </div>
              )}

              {vehiculo.info.preventa.descripcion_subtitulo_principal !== "" && (
                <div className="vehicle-footer-descripcion-subtitulo-principal">
                  <p>{vehiculo.info.preventa.descripcion_subtitulo_principal}</p>
                </div>
              )}

              <div className="vehicle-footer-titulo-principal">
                {vehiculo.info.preventa.titulo_principal !== "" &&
                  ConvertirStringHTML(vehiculo.info.preventa.titulo_principal, "vehicle-footer-titulo-principal-a")}

                {vehiculo.info.preventa.descripcion_titulo_principal !== "" &&
                  ConvertirStringHTML(
                    vehiculo.info.preventa.descripcion_titulo_principal,
                    "vehicle-footer-titulo-principal-b"
                  )}

                {vehiculo.info.preventa.descripcion_rojo_titulo_principal !== "" &&
                  ConvertirStringHTML(
                    vehiculo.info.preventa.descripcion_rojo_titulo_principal,
                    "vehicle-footer-titulo-principal-c"
                  )}
              </div>
            </div>
          </div>

                <div>
                  <button
                    type="button"
                    className="btn-consultar-card"
                    id={`${card.modelo.replace(/\s+/g, "-").toLowerCase()}-${tipo}`}
                    onClick={interaction.buttonOnClick}
                  >
                    Consultar
                  </button>
                </div>
              </section>
            );
          })()
        : null}
    </div>
  );
};

export default VehicleCard;
